import { BUILD_ENV, type BUILD_ENV_TYPE } from "@web3auth/auth";
import { LogLevelDesc } from "loglevel";

import {
  DEVELOP_PASSWORDLESS_SERVER_API_URL,
  DEVELOP_PASSWORDLESS_SERVER_SOCKET_URL,
  PASSWORDLESS_SERVER_API_URL,
  PASSWORDLESS_SERVER_SOCKET_URL,
} from "./utils/constants";

export interface ConfigBuild {
  authServerUrl: string;
  socketUrl: string;
  sentrySampleRate: string;
  supportsVersioning: boolean;
  logLevel: LogLevelDesc;
}

const configBuild: Record<BUILD_ENV_TYPE, ConfigBuild> = {
  [BUILD_ENV.DEVELOPMENT]: {
    authServerUrl: DEVELOP_PASSWORDLESS_SERVER_API_URL,
    socketUrl: DEVELOP_PASSWORDLESS_SERVER_SOCKET_URL,
    logLevel: "debug",
    sentrySampleRate: "0.0",
    supportsVersioning: false,
  },
  [BUILD_ENV.STAGING]: {
    authServerUrl: PASSWORDLESS_SERVER_API_URL,
    socketUrl: PASSWORDLESS_SERVER_SOCKET_URL,
    logLevel: "debug",
    sentrySampleRate: "0.1",
    supportsVersioning: true,
  },
  [BUILD_ENV.PRODUCTION]: {
    authServerUrl: PASSWORDLESS_SERVER_API_URL,
    socketUrl: PASSWORDLESS_SERVER_SOCKET_URL,
    logLevel: "error",
    sentrySampleRate: "0.01",
    supportsVersioning: true,
  },
  [BUILD_ENV.TESTING]: {
    authServerUrl: DEVELOP_PASSWORDLESS_SERVER_API_URL,
    socketUrl: DEVELOP_PASSWORDLESS_SERVER_SOCKET_URL,
    logLevel: "debug",
    sentrySampleRate: "1",
    supportsVersioning: false,
  },
};

export default configBuild;
